<template>
  <div>
    <a class="btn_rating" v-if="isRental" @click="openRateModal">
      {{ $t('rating.rate_btn_title') }}</a
    >
    <v-layout row align-center v-else-if="!disabledActivator">
      <Rating
        read-only
        :disabledRating="disabledRating"
        :rate-value="disabledRating ? rateFromData.rating : 0"
        @onOpenModal="openRateModal"
        @onChangeRateValue="updateRatingValue"
      />
    </v-layout>

    <v-dialog
      v-if="showDialog"
      v-model="showDialog"
      max-width="480px"
      persistent
      no-click-animation
      content-class="rating-modal"
    >
      <div><v-icon color="grey" @click="cancelRating">close</v-icon></div>

      <div class="rating-modal__rate">
        <Rating @onChangeRateValue="updateRatingValue" :rateValue="rateFromData.rating || 0" />
      </div>

      <div class="mt-3 subheading" v-if="reasonsVisible">{{ selectReasonTitle }}</div>
      <div class="rating-feedback" v-if="reasonsVisible">
        <v-list two-line my-2 wrap reasons v-if="!isLoading">
          <template v-for="reason in reasonList">
            <v-list-tile
              class="reason"
              :class="{ active: isActiveReason(reason) }"
              :key="reason.key"
              @click="onSelectReason(reason)"
            >
              <v-list-tile-content>
                <v-list-tile-title v-text="reason.value" class="reason-label"> </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-checkbox :inputValue="selectedReasons.includes(reason)"></v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        <v-list two-line my-2 wrap reasons v-if="isLoading">
          <div class="reason-loading">
            <v-progress-circular indeterminate color="#ea5800"></v-progress-circular>
          </div>
        </v-list>
      </div>
      <div v-else class="rating-feedback pt-2">
        <v-flex class="mt-3 favorite-driver">
          <div class="favorite-driver__des">
            {{
              isFavoriteDriver || addedDriver
                ? $t('rating.favorite_driver_des')
                : $t('rating.non_favorite_driver_des')
            }}
          </div>

          <div class="favorite-driver__highlight">
            <div class="favorite-driver__action" @click="toggleDriver(isFavoriteDriver)">
              <SvgIcon
                height="18"
                width="20"
                :icon="isFavoriteDriver || addedDriver ? 'Heart' : 'HeartOutline'"
              />
            </div>
            <div class="favorite-driver__title">
              {{
                isFavoriteDriver || addedDriver
                  ? $t('rating.favorite_driver')
                  : $t('rating.non_favorite_driver')
              }}
            </div>
          </div>
        </v-flex>

        <div class="mt-3 subheading" v-if="!reasonsVisible">{{ selectReasonTitle }}</div>

        <v-container fluid px-0 pt-2 class="container-thanksfull">
          <v-layout row wrap>
            <v-flex
              v-for="reason in thanksfullList"
              my-2
              xs4
              md3
              xl3
              align-center
              text-xs-center
              :key="reason.key"
              class="thanksfull"
              :class="{ active: isActiveReason(reason) }"
              @click="onSelectReason(reason)"
            >
              <div class="reason-thanks">
                <!-- <SvgIcon height="64" width="64" :icon="reason.image_url" /> -->
                <img :src="reason.image" height="64" width="64" />
              </div>
              <span>{{ reason.value }}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <div class="leave-feedback">
        <div class="feedback-action justify-center" v-if="!isShowTextArea" @click="showTextArea">
          <SvgIcon height="24" width="24" icon="PlusIcon" />
          <p>{{ $t('rating.leave_a_feedback') }}</p>
        </div>
        <div v-else>
          <ATextArea
            dark
            noResize
            rows="3"
            :value="comment"
            :label="commentPlaceholder"
            @onChange="handleUpdateComment"
          />
          <span class="feedback-note">{{
            $t('rating.maximum_character_feedback', { numbers: 6 })
          }}</span>
        </div>
      </div>

      <div class="rating-modal__actions">
        <v-btn
          depressed
          color="accent"
          @click="submitRating"
          :disabled="disabledSubmit || submitProcessing"
          :loading="submitProcessing"
          name="btnSendRating"
          >{{ $t('send') }}</v-btn
        >
      </div>

      <v-snackbar
        v-model="alert_limit"
        bottom
        auto-height
        :color="'#fff'"
        :timeout="2000"
        class="limited_driver"
      >
        <SvgIcon class="mb-3 pb-1" height="16" width="16" :icon="'Error'" />
        <div class="snackbar-text-black ml-3">
          {{ text_alert }}
        </div>
      </v-snackbar>
    </v-dialog>

    <!-- model confirm add favorite driver -->
    <v-dialog
      v-model="showModalConfirmAddFavoriteDriver"
      max-width="343px"
      content-class="modal-confirm"
      :transition="isMobile ? 'dialog-bottom-transition' : 'dialog-transition'"
    >
      <v-card>
        <v-img
          src="/assets/images/FavoriteDriver.png"
          width="96px"
          height="auto"
          alt="favorite driver"
          cover
        ></v-img>

        <v-card-title class="favorite-driver__confirm-title mt-2">
          {{ $t('favorite-drivers.add_favorite_driver_to_list') }}</v-card-title
        >

        <v-card-text class="favorite-driver__confirm-des mt-2">{{
          $t('favorite-drivers.add_favorite_driver_description')
        }}</v-card-text>

        <v-card-actions class="favorite-driver__confirm-action mt-3">
          <v-flex xs6>
            <v-btn
              large
              depressed
              color="#E6E9EC"
              class="text-none"
              @click="showModalConfirmAddFavoriteDriver = false"
              >{{ $t('favorite-drivers.cancel') }}</v-btn
            >
          </v-flex>

          <v-flex xs6 ml-3>
            <v-btn
              large
              depressed
              class="text-none"
              color="btn-confirm-color primary_50"
              @click="toggleDriver(isFavoriteDriver, true)"
              >{{ $t('favorite-drivers.add') }}</v-btn
            >
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="showInvite">
      <div v-if="inviteDialogVisible">
        <InviteFriends />
      </div>
    </div>
    <v-snackbar v-model="alert" bottom auto-height :color="'#fff'" :timeout="2000">
      <SvgIcon height="14" width="14" :icon="success ? 'Success' : 'Error'" />
      <div class="snackbar-text-black ml-3">
        {{ success ? $t(`favorite-drivers.${text_alert}`) : text_alert }}
      </div>
    </v-snackbar>
  </div>
</template>
<script>
import Rating from '../records/Rating'
import InviteFriends from './InviteFriends'
import ATextArea from '@/components/ahamove/ATextArea'
import { mapGetters, mapState } from 'vuex'
import { rateSupplierV3 } from '@/store/api/order'

const { findIndex, find } = require('@/plugins/lodash')

const PERFECT_RATE = 5
const VALID_CHARACTER_FEEDBACK = 6

export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    showInvite: {
      type: Boolean,
      required: false,
      default: false
    },
    disabledActivator: {
      type: Boolean,
      default: false
    },
    isRental: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    }
  },
  components: {
    Rating,
    InviteFriends,
    ATextArea
  },
  data() {
    return {
      reasonList: [],
      thanksfullList: [],
      showDialog: false,
      selectedReasons: [],
      comment: '',
      rateFromData: {
        rating: 0
      },
      submitProcessing: false,
      ticketCreating: false,
      inviteDialogVisible: false,
      disabledRating: false,
      disabledSubmit: false,
      isShowTextArea: false,
      addedDriver: false,
      alert: false,
      success: false,
      text_alert: '',
      isLoading: false,
      showFavoriteDriver: false,
      alert_limit: false,
      showModalConfirmAddFavoriteDriver: false
    }
  },
  computed: {
    ...mapGetters(['token', 'badgeList', 'userProfile', 'favorite_drivers', 'ratingComments']),
    ...mapState({
      favoriteDrivers: (state) => state.user.favorite_drivers
    }),
    // validateCharacter() {
    //   // this.$t('rating.maximum_character_feedback', {numbers: VALID_CHARACTER_FEEDBACK})
    //   return v => v && v.length >= VALID_CHARACTER_FEEDBACK || '';
    // },
    reasonsVisible() {
      return this.rateFromData.rating < PERFECT_RATE && this.rateFromData.rating > 0
    },
    selectReasonTitle() {
      let rateNumber = this.rateFromData.rating
      let title = rateNumber < 3 ? 'bad' : rateNumber < 5 ? 'mid' : 'good'
      return this.$t('rating.select_reason_title.' + title)
    },
    commentPlaceholder() {
      let rateNumber = this.rateFromData.rating
      let title = rateNumber < 3 ? 'bad' : rateNumber < 5 ? 'mid' : 'good'
      return this.$t('rating.comment_placeholder.' + title)
    },
    isFavoriteDriver() {
      return this.favoriteDrivers.some(
        (e) => e._id === (this.isRental ? this.item.supplier_id : this.order.supplier_id)
      )
    }
  },
  methods: {
    showTextArea() {
      this.isShowTextArea = true
    },
    handleUpdateComment(input) {
      this.comment = input

      if (this.rateFromData.rating < PERFECT_RATE) {
        if (this.comment && this.comment.length >= VALID_CHARACTER_FEEDBACK) {
          this.disabledSubmit = false
        } else {
          this.disabledSubmit = true
        }

        if (this.comment.length == 0 && this.selectedReasons && this.selectedReasons.length !== 0) {
          this.disabledSubmit = false
        }
      } else {
        if (this.comment.length >= VALID_CHARACTER_FEEDBACK || this.comment.length === 0) {
          this.disabledSubmit = false
        } else {
          this.disabledSubmit = true
        }
      }
    },
    closeDialog() {
      this.showRateSuccessDialog = false
    },
    openRateModal() {
      this.updateRatingValue(5)
      this.showDialog = true
      this.getBadgeList()
      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS.ORDER_DETAIL_SHOW_RATING_FORM_BTN,
        {
          order: this.order
        }
      )
    },
    updateRatingValue(newVal) {
      this.selectedReasons.length = 0
      this.isShowTextArea = false
      this.comment = null

      if (newVal < PERFECT_RATE) {
        this.getReasonList(newVal)

        this.disabledSubmit = true
      } else {
        this.disabledSubmit = false
      }

      if (newVal !== this.rateFromData.rating) {
        this.rateFromData.rating = newVal
      }
    },
    cancelRating() {
      this.showDialog = false
      this.$emit('hiddenRatingLastestOrder')
      this.initRateForm()
      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS.RATE_SUPPLIER_CLOSE_BTN,
        {}
      )
    },
    onSelectReason(reason) {
      const reasonIndex = findIndex(this.selectedReasons, { key: reason.key })

      if (reasonIndex > -1) {
        this.selectedReasons.splice(reasonIndex, 1)
      } else {
        this.selectedReasons.push(reason)
      }

      // RULES:
      // Rating === 5, Do not need choose bagde or write feedback
      // Rating < 5, Must choose at least 1 tag or write feedback

      if (this.rateFromData.rating < PERFECT_RATE) {
        if (this.selectedReasons && this.selectedReasons.length > 0) {
          if (!this.comment || this.comment.length == 0) {
            this.disabledSubmit = false
          } else {
            if (this.comment.length >= VALID_CHARACTER_FEEDBACK) {
              this.disabledSubmit = false
            } else {
              this.disabledSubmit = true
            }
          }
        } else {
          if (this.comment && this.comment.length >= VALID_CHARACTER_FEEDBACK) {
            this.disabledSubmit = false
          } else {
            this.disabledSubmit = true
          }
        }
      }
    },
    isActiveReason(reason) {
      const reasonIndex = findIndex(this.selectedReasons, { key: reason.key })
      return reasonIndex > -1 ? true : false
    },
    submitRating() {
      if (!this.rateFromData.rating || this.rateFromData.rating === 0) {
        const error = {
          visible: true,
          title: this.$t('rating.rate_title'),
          color: 'error'
        }
        return this.$store.dispatch('setSnackbar', error)
      }

      // Prevent multiple submissions
      if (this.submitProcessing) {
        const error = {
          visible: true,
          title: 'Processing...',
          color: 'error'
        }
        return this.$store.dispatch('setSnackbar', error)
      }

      this.submitProcessing = true

      if (this.comment === null) {
        this.comment = ''
      }

      if (this.rateFromData.rating < PERFECT_RATE) {
        let comments = this.selectedReasons.map((reason) => {
          return reason.value
        })
        this.rateFromData.comment = comments.join(' ') + ' ' + this.comment.trim()
        this.rateFromData.comment = this.rateFromData.comment.trim()
        if (this.rateFromData.badge_ids) delete this.rateFromData.badge_ids
        this.createTicket()
      } else {
        let comments = this.selectedReasons.map((reason) => {
          return reason.key
        })
        this.rateFromData.comment = this.comment.trim()
        this.rateFromData.badge_ids = comments
      }

      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS.RATE_SUPPLIER_SUBMIT_BTN,
        {
          rateForm: this.rateFromData
        },
        undefined,
        {
          rating: `${this.rateFromData.rating}`,
          comment: this.rateFromData.comment
        }
      )

      this.sendRatingV3()
        .then(() => {
          this.showDialog = false
          // emit to update rating of oder
          this.$emit('onUpdateRating', {
            rating: this.rateFromData.rating,
            comment: this.rateFromData.comment,
            badge_ids: this.rateFromData.badge_ids || ''
          })
          if (this.showInvite) this.inviteDialogVisible = true
          this.disabledRating = true
        })
        .catch(() => {
          const error = {
            visible: true,
            title: this.$t('rating.submit_error'),
            color: 'error'
          }
          this.$store.dispatch('setSnackbar', error)
        })
        .finally(() => {
          this.submitProcessing = false
        })
    },
    sendRating() {
      const params = Object.assign({}, this.rateFromData, {
        token: this.$store.getters.token,
        order_id: this.item ? this.item._id : this.order._id // send rating child order or order
      })
      return new Promise((resolve, reject) => {
        const api = process.env.VUE_APP_API_URL.concat(this.$constants.API.order.rate_supplier)
        this.axios
          .get(api, { params: params })
          .then((response) => {
            resolve(response)
          })
          .catch(() => {
            reject()
          })
      })
    },
    sendRatingV3() {
      if (!this.rateFromData || !this.order._id) return

      const params = { ...this.rateFromData, rated_by: 'user' }
      const orderId = this.item ? this.item._id : this.order._id

      return new Promise((resolve, reject) => {
        rateSupplierV3(orderId, params)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    createTicket() {
      // Prevent spam ticket creation
      if (this.ticketCreating) {
        return Promise.resolve()
      }

      this.ticketCreating = true

      let ticket = {
        subject: `USER : ${this.userProfile.city_id[0]} - ${this.userProfile._id} : BAD RATING - ${this.rateFromData.rating}*`,
        order_id: this.item ? this.item._id : this.order._id,
        type: 'ahamove_bad_rating',
        token: this.$store.getters.token,
        description: `Rating: ${this.rateFromData.rating}* \n Reason: ${this.rateFromData.comment} \n Summit From: ${window.location}`
      }
      return new Promise((resolve, reject) => {
        const api = process.env.VUE_APP_API_URL.concat(this.$constants.API.order.create_ticket)
        this.axios
          .get(api, { params: ticket })
          .then((response) => {
            resolve(response)
          })
          .catch(() => {
            reject()
          })
          .finally(() => {
            this.ticketCreating = false
          })
      })
    },
    initRateForm() {
      this.rateFromData.rating = this.order.rating_by_user
      if (this.rateFromData.rating > 0) {
        this.disabledRating = true
        return
      }
      if (this.order.comment_by_user) {
        let comment = this.order.comment_by_user
        let reasons = comment.match(/[^[]+(?=])/g)
        if (reasons.length > 0) {
          reasons.forEach((key) => {
            const reason = find(this.reasonList, { value: '[' + key + ']' })
            this.selectedReasons.push(reason)
          })
          const startCommentIndex = comment.lastIndexOf(']') + 1
          this.comment = comment.substr(startCommentIndex).trim()
        } else {
          this.comment = comment
        }
      }
    },
    getDurationLabel(second) {
      let label = ''

      let duration = this.$moment.duration(second, 'seconds')
      let days = duration.days()
      let hours = duration.hours()
      let minutes = duration.minutes()
      let seconds = duration.seconds()

      label += days && days > 0 ? days + this.$t('rating.DAY') + ' ' : ''
      label += hours && hours > 0 ? hours + this.$t('rating.HOUR') + ' ' : ''
      label += minutes && minutes > 0 ? minutes + this.$t('rating.MINUTE') + ' ' : ''
      label += seconds && seconds > 0 ? seconds + this.$t('rating.SECOND') + ' ' : ''

      return label && label.trim()
    },
    async toggleDriver(isFavoriteDriver, confirmAdd = false) {
      const params = { supplier_id: this.isRental ? this.item.supplier_id : this.order.supplier_id }

      let action = 'addFavoriteDriver'
      let message = 'add_success'
      if (isFavoriteDriver) {
        action = 'removeFavoriteDriver'
        message = 'remove_success'
      }

      if (!confirmAdd) {
        if (action === 'addFavoriteDriver') {
          if (
            this.favoriteDrivers &&
            this.favoriteDrivers.length >= this.$constants.MAX_FAVORITED_DRIVER
          ) {
            this.alert_limit = true

            this.text_alert = `${this.$t('favorite-drivers.limited_favorite_driver')}`
            return
          }

          if (
            !isFavoriteDriver &&
            this.favoriteDrivers &&
            this.favoriteDrivers.length < this.$constants.MAX_FAVORITED_DRIVER
          ) {
            this.showModalConfirmAddFavoriteDriver = true
            return
          }
        }
      }

      const response = await this.$store.dispatch(action, params)
      if (response && response.error) {
        this.alert = true
        this.success = false
        this.text_alert = response.error.description
        return
      }

      this.alert = true
      this.success = true
      this.text_alert = message
      this.showModalConfirmAddFavoriteDriver = false

      this.$store.dispatch('getListFavoriteDriver')
    },
    handleAddFavoriteDriver() {
      const action = 'addFavoriteDriver'
      const params = { supplier_id: this.isRental ? this.item.supplier_id : this.order.supplier_id }

      const response = this.$store.dispatch(action, params)
      if (response && response.error) {
        this.alert = true
        this.success = false
        this.text_alert = response.error.description
        return
      }

      this.$store.dispatch('getListFavoriteDriver')
    },
    getReasonList(groupStar) {
      const ratingParams = {
        reason_type: 'rating',
        user_type: 'user',
        service_id: this.order.service_id && this.order.service_id,
        group_star: groupStar,
        delivery_type: this.order.service && this.order.service.delivery_type
      }

      const isUpdateGroupStar = groupStar !== this.rateFromData.rating

      if (isUpdateGroupStar) this.reasonList = []

      this.isLoading = true
      if (this.ratingComments.length === 0 || isUpdateGroupStar) {
        this.$store
          .dispatch('setRatingComments', ratingParams)
          .then((response) => {
            this.isLoading = false
            if (response && response.status === 200) {
              response.data.forEach((val) => {
                this.reasonList.push({
                  key: val._id,
                  value:
                    this.$store.getters.locale === this.$constants.LOCATE_LANGUAGE.VI.locate
                      ? val.title_vi
                      : val.title_en
                })
              })
            }
          })
          .catch(() => {
            this.reasonList = []
          })
      } else {
        this.isLoading = false
        this.ratingComments.forEach((val) => {
          this.reasonList.push({
            key: val.code,
            value:
              this.$store.getters.locale === this.$constants.LOCATE_LANGUAGE.VI.locate
                ? val.title_vi
                : val.title_en
          })
        })
      }
    },
    getBadgeList() {
      const locale = this.$store.getters.locale

      if (this.showDialog) this.thanksfullList = []

      if (this.badgeList.length === 0 || this.showDialog) {
        this.$store
          .dispatch(
            'setBadgeList',
            this.order && this.order.service && this.order.service.delivery_type
          )
          .then((response) => {
            if (response && response.status === 200) {
              response.data.forEach((val) => {
                this.thanksfullList.push({
                  key: val.code,
                  value:
                    locale === this.$constants.LOCATE_LANGUAGE.VI.locate
                      ? val.name.vi
                      : val.name.en,
                  image: val.image_url,
                  type: val.type,
                  index: val.index
                })
              })
            }
          })
          .catch(() => {
            this.thanksfullList = []
          })
      } else {
        this.badgeList.forEach((val) => {
          this.thanksfullList.push({
            key: val.code,
            value: locale === this.$constants.LOCATE_LANGUAGE.VI.locate ? val.name.vi : val.name.en,
            image: val.image_url,
            type: val.type,
            index: val.index
          })
        })
      }
    }
  },
  async created() {
    await this.$store.dispatch('getListFavoriteDriver')
  },
  beforeMount() {
    this.getBadgeList()

    this.initRateForm()
  },
  watch: {
    selectedReasons(newVal) {
      if (!newVal) {
        this.disabledSubmit = true
      }
    },
    order(newVal, oldVal) {
      if (newVal && oldVal && newVal._id !== oldVal._id) {
        this.badgeList = []
        this.thanksfullList = []
        this.getBadgeList()
      }
    }
  }
}
</script>

<i18n>
  {
    "en": {
      "rating": {
      "rate_btn_title" : "rate",
      "board_time": "Boarded at",
      "complete_time": "Complete at",
      "cancel_time": "Cancel time",
      "rate_title": "What do you think about our driver?",
      "you_rated": "You rated",
      "maximum_character_feedback" : "* Must be at least {numbers} characters ",
      "leave_a_feedback" : "Leave feedback",
      "reasons": {
        "reason_1": "Driver's attitude",
        "reason_2": "Damaged/Lost packages",
        "reason_3": "Pickup Time",
        "reason_4": "Delivery Time",
        "reason_5": "No Uniform",
        "reason_6": "Overcharging",
        "reason_7": "Different Driver",
        "reason_8": "Others"
      },
      "thanksfull" : {
        "perfect_service": "Perfect service",
        "enthusiast_driver": "Enthusiast driver",
        "friendly_driver": "Friendly driver",
        "driver_is_good_at_navigation": "Driver is good at navigation",
        "vehicle_full_of_conveniences": "Vehicle full of conveniences",
        "vehicle_looks_impressive": "Vehicle looks impressive",
        "clean_and_comfortable_vehicle": "Clean and comfortable vehicle"
      },
      "select_reason_title": {
        "bad": "What made you unsatisfied?",
        "mid": "How can we improve?",
        "good": "Excellent service"
      },
      "comment_placeholder": {
        "bad": "Enter your comment",
        "mid": "Enter your comment",
        "good": "Enter your comment"
      },
      "cancel": "Back",
      "invalid_comment": "Please đcomment more than 6 characters",
      "missing_reason": "Please select a answer",
      "submit_error": "Cannot submit. Please try again.",
      "order": "Order",
      "DAY": "days",
      "HOUR": "hours",
      "MINUTE": "mins",
      "SECOND": "secs",
      "non_favorite_driver": "Add as favorite driver",
      "favorite_driver": "Added as favorite driver",
      "favorite_driver_des": "This driver will be prioritized to pick up your orders in the future",
      "non_favorite_driver_des": "Your next order will be prioritized for your favorite drivers"
      },
      "favorite-drivers": {
        "add_success": "Add driver success",
        "remove_success": "Remove driver success",
        "limited_favorite_driver": "Add favorite driver failed. Your list is already full.",
        "add_favorite_driver_to_list": "Add your favorite driver to the list",
        "add_favorite_driver_description": "Your favorite driver will be given priority to receive your order. Are you sure you want to add to the list?",
        "cancel":"Cancel",
        "add": "Add"
      }
    },
    "vi": {
      "rating": {
      "rate_btn_title" : "Đánh giá",
      "board_time": "Đến nơi lúc",
      "complete_time": "Hoàn thành lúc",
      "cancel_time": "Huỷ lúc",
      "rate_title": "Vui lòng đánh giá tài xế",
      "you_rated": "Bạn đã đánh giá",
      "maximum_character_feedback" : "Vui lòng nhập ít nhất {numbers} ký tự",
      "leave_a_feedback" : "Để lại phản hồi",
      "reasons": {
        "reason_1": "Thái độ không tốt",
        "reason_2": "Mất/hỏng hàng",
        "reason_3": "Lấy hàng trễ",
        "reason_4": "Thời gian giao hàng",
        "reason_5": "Thiếu đồng phục",
        "reason_6": "Thu sai tiền",
        "reason_7": "Tài xế không đúng",
        "reason_8": "Khác"
      },
      "thanksfull" : {
        "perfect_service": "Dịch vụ hoàn hảo",
        "enthusiast_driver": "Tài xế nhiệt tình",
        "friendly_driver": "Tài xế thân thiện",
        "driver_is_good_at_navigation": "Tài xế tìm đường đi tốt",
        "vehicle_full_of_conveniences": "Đầy đủ tiện nghi trên xe",
        "vehicle_looks_impressive": "Kiểu dáng xe ấn tượng",
        "clean_and_comfortable_vehicle": "Xe sạch sẽ và thoải mái"
      },
      "select_reason_title": {
        "bad": "Điều gì làm bạn thấy chưa tốt?",
        "mid": "Chúng tôi cần cải thiện điều gì?",
        "good": "Dịch vụ hoàn hảo"
      },
      "comment_placeholder": {
        "bad": "Nhập bình luận của bạn",
        "mid": "Nhập bình luận của bạn",
        "good": "Nhập bình luận của bạn"
      },
      "cancel": "Quay lại",
      "invalid_comment": "Vui lòng để lại nhận xét nhiều hơn 6 kí tự",
      "missing_reason": "Vui lòng chọn 1 câu trả lời",
      "submit_error": "Không thể gửi. Vui lòng thử lại.",
      "order": "Đơn hàng",
      "DAY": "ngày",
      "HOUR": "giờ",
      "MINUTE": "phút",
      "SECOND": "giây",
      "non_favorite_driver": "Thêm tài xế yêu thích",
      "favorite_driver": "Đã thêm tài xế yêu thích",
      "favorite_driver_des": "Tài xế này sẽ được ưu tiên nhận các đơn hàng tiếp theo của bạn",
      "non_favorite_driver_des": "Ưu tiên giao đơn hàng tiếp theo với tài xế mà bạn yêu thích"
      },
      "favorite-drivers": {
        "add_success": "Đã thêm tài xế vào danh sách yêu thích",
        "remove_success": "Đã xoá tài xế khỏi danh sách yêu thích",
        "limited_favorite_driver": "Thêm tài xế yêu thích thất bại. Danh sách của bạn vượt quá quy định.",
        "add_favorite_driver_to_list": "Thêm tài xế yêu thích vào danh sách",
        "add_favorite_driver_description": "Tài xế yêu thích sẽ được ưu tiên nhận đơn hàng của bạn. Bạn có chắc chắn muốn thêm vào danh sách?",
        "cancel":"Hủy",
        "add": "Thêm"
      }
    }
  }
</i18n>

<style lang="scss" scoped>
.btn_rating {
  border: none;
  box-shadow: none;
  color: #ea5800;
  font-weight: 700;
  line-height: 24px;
}

.snackbar-text-black {
  color: #000;
}

.map {
  height: 150px;
  background: #f5f5ff;
}

.supplier-star {
  font-size: 17px;
  color: #fecf5f;
}

.favorite-driver {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__highlight {
    display: flex;
    align-items: center;
    max-width: 45%;
    padding: 12px;
    border: 1px solid #c1c7cd;
    border-radius: 48px;
  }

  &__confirm-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
  }

  &__confirm-des {
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    padding-top: 0;
  }

  &__confirm-action {
    padding-right: 32px;

    .v-btn {
      width: 100% !important;
      border-radius: 4px;
    }

    .btn-confirm-color {
      color: #fff;
    }
  }
}

.favorite-driver__des {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #7a8189;
  max-width: 55%;
}

.favorite-driver__action {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 8px;
}

.favorite-driver__title {
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  color: #1a1a1a;
}

.reason {
  cursor: pointer;
  box-sizing: border-box;
  color: #1a1a1a;
  line-height: 20px;
  font-size: 14px;

  a {
    display: flex;
  }

  &-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 300px;
  }
}
</style>

<style lang="scss">
.rating-modal,
.rating-modal__success {
  background-color: #fff;
  border-radius: 4px;
  padding: 16px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .v-icon {
    text-align: right;
    justify-content: flex-end;
    float: right;
  }

  .rating-feedback {
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    overflow-y: scroll;

    .reasons {
      margin-bottom: -35px;
    }

    .container-thanksfull {
      margin-bottom: -24px;
    }

    .thanksfull {
      margin: 0 24px 24px 0;
      width: 80px;
      max-width: 80px;
      min-height: 122px;
      cursor: pointer;

      .reason-thanks {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin: 0 auto 4px;

        img {
          width: 100%;
          height: auto;
        }
      }

      span {
        font-size: 12px;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.65);
      }
    }

    .thanksfull.active {
      .reason-thanks {
        width: 72px;
        height: 72px;
      }

      span {
        font-size: 14px;
        line-height: 20px;
        font-weight: 700;
      }
    }
  }

  .rating-feedback::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }

  .leave-feedback {
    padding: 24px 0;
  }

  .feedback-action {
    display: flex;
    align-items: center;
    margin: 0 auto;
    cursor: pointer;

    p {
      margin-bottom: 0;
      color: #ff8200;
      font-weight: 600;
    }
  }

  .feedback-note {
    font-size: 14px;
    color: gray;
  }

  .rating-modal__supplier {
    text-align: center;

    .supplier__name {
      margin-top: 12px;
      color: #1a1a1a;
    }

    .supplier__avatar {
      position: relative;

      .supplier__rate {
        position: absolute;
        bottom: -10px;
        left: 3px;
        background-color: #fff;
        padding: 0 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
        border-radius: 26px;
        font-weight: 500;
        display: flex;
        align-items: baseline;
        justify-content: center;

        .star-icon {
          margin-left: 4px;
        }
      }
    }
  }

  .rating-modal__rate {
    margin-top: 16px;
    display: flex;
    justify-content: center;
  }

  .subheading {
    font-weight: 500;
    color: #1a1a1a;
    padding-left: 5px;
  }

  .rating-modal__actions {
    padding: 16px;
    margin: 12px -16px 0 -16px;
    box-shadow: rgba(100, 100, 111, 0.2) 0 -4px 8px 0;
    padding-bottom: 0;

    button {
      flex: 1;
      margin: 0;
      text-transform: none;
      height: 44px;
      width: 100%;
    }

    // button:first-child {
    //   margin-bottom: 10px;
    // }
  }

  .v-input {
    &__slot {
      justify-content: end;
    }

    &__control {
      width: 100%;
    }
  }

  .limited_driver {
    bottom: 0;

    .v-snack__wrapper {
      width: 360px;
      background-color: #ffebea !important;

      .v-snack__content {
        padding: 16px;
      }
    }
  }
}

.modal-confirm {
  .v-card {
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    > * {
      padding: 0;
    }
  }
}

.rating-modal__success {
  .icon-feedback {
    margin: 0 auto;
  }

  p {
    color: #7a8189;
    font-weight: 500;
    max-width: 326px;
    text-align: center;
    margin: 0 auto;
    padding: 20px 0;
  }
}

@media screen and (max-width: 480px) {
  .rating-modal {
    &.v-dialog {
      margin: 0;
      margin-top: auto;
      max-height: 90% !important;
      border-radius: 8px 8px 0 0;
    }
  }
}
</style>
